export default __webpack_public_path__ + "2b0798d61724826c205f9f6db013b6ee.png";